import { Agent } from "../models/agent";

import BaseService from "./_base.service";
import API from "../api";
import { AxiosResponse } from "axios";

const ROUTE_NAME = "agents";

const AgentService = {
  ...BaseService<Agent>({ endpoint: ROUTE_NAME }),
  async inviteToShipeezi(inviteParams: { agentId: number, createdCompany: boolean}): Promise<AxiosResponse<boolean>> {
    return await API.post(`/${ROUTE_NAME}/invite`, inviteParams);
  },
  async revoke(revokeParams: { agentId?: number; companyId?: number }): Promise<AxiosResponse<Agent>> {
    return await API.delete(`/${ROUTE_NAME}/revoke`, {
      params: revokeParams,
    });
  },
  async rejectInvite(revokeParams: { token: string }) {
    return await API.put(`/${ROUTE_NAME}/invite/reject`, revokeParams);  
  },
  async acceptInvite(revokeParams: { token: string, password?: string }) {
    return await API.put(`/${ROUTE_NAME}/invite/accept`, revokeParams);  
  },
  async acceptInviteAndAssociate(revokeParams: { token: string, selectedCompanyId: number }) {
    return await API.put(`/${ROUTE_NAME}/invite/accept-and-associate`, revokeParams);  
  },
  async validateInvite(revokeParams: { token: string }) {
    return await API.post(`/${ROUTE_NAME}/invite/validate`, revokeParams);  
  },
};

export default AgentService;
